import { css } from 'styled-components';
import token from 'styled-token';
import { spaceMixin } from '../spaceMixin';

/** @class CarouselHeaderMixin */
/** @method */
export var CarouselHeaderMixin = function CarouselHeaderMixin(props) {
  return token({
    gridGap: 'CarouselHeader.gridGap',
    paddingBottom: 'CarouselHeader.paddingBottom'
  }, function (_ref) {
    var gridGap = _ref.gridGap,
      paddingBottom = _ref.paddingBottom;
    return css(["align-items:center;display:grid;grid-auto-flow:column;grid-gap:", ";justify-content:space-between;padding-bottom:", ";"], gridGap ? gridGap + "px" : spaceMixin('lg')(props), paddingBottom ? paddingBottom + "px" : spaceMixin('xs')(props));
  })(props);
};